import { apiRequest, apiEndPoints, methodType } from "./_apiConfig";

export const citiesRequest = async (data = {}) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.authCities,
    data,
    true
  );
};

export const banksRequest = async (data = {}) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.getBanks,
    data,
    true
  );
};

export const occupationRequest = async (data = {}) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.authOccupation,
    data,
    true
  );
};

export const nationalityRequest = async (data = {}) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.authNationality,
    data,
    true
  );
};

export const industrySectorRequest = async (data = {}) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.authIndustrySector,
    data,
    false
  );
};

export const getKycStatus = async () => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.kycStatus,
    {},
    true
  );
};
